import clsx from 'clsx';
import React from 'react';

import { ProButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import { useEventTracking } from '@hooks/index';
import { upgrade_subscription_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { PRO_OFFERING_IMG_LINK } from './constants';

export interface ProUpgradePromoProps {
  isMobile?: boolean;
}

const ProUpgradePromo = ({ isMobile = false }: ProUpgradePromoProps) => {
  const { trackEvent } = useEventTracking();
  return (
    <div
      className={clsx(
        'flex flex-col items-center',
        isMobile ? 'w-full justify-center border border-solid border-pro-gold px-32 py-16' : ''
      )}
    >
      <LazyImgixImage
        src={PRO_OFFERING_IMG_LINK}
        alt="The Information Pro"
        className="w-full"
        wrapperClassName={isMobile ? 'w-[200px]' : 'w-[350px]'}
      />
      <h3
        className={clsx(
          'mb-0 font-suisse-works text-pro-gold',
          isMobile ? 'text-headline-xxs' : 'text-headline-sm'
        )}
      >
        The Information Pro
      </h3>
      <p
        className={clsx(
          'max-w-[440px] text-center font-suisse-screen',
          isMobile ? 'mb-16 text-byline-sm' : 'mb-48 text-byline-lg'
        )}
      >
        Get full access to 60+ org charts, 15+ proprietary databases, Deep Research, exclusive
        events, surveys and more.
      </p>
      <ProButton
        as="link"
        size={isMobile ? 'small' : 'big'}
        href={upgrade_subscription_path()}
        onClickCapture={() => {
          trackEvent(click({ clickTarget: ClickTarget.Button, clickText: 'Upgrade to Pro' }));
        }}
        className={clsx(
          'border-pro-gold !bg-pro-gold text-button-sm hover:!border-pro-gold hover:!bg-transparent hover:!text-pro-gold focus:!border-pro-gold focus:!bg-pro-gold focus:!text-white',
          isMobile ? '!w-full' : '!w-[340px]'
        )}
      >
        Upgrade to Pro
      </ProButton>
    </div>
  );
};

export default ProUpgradePromo;
